import { render, staticRenderFns } from "./ReadMoreButton.vue?vue&type=template&id=2a3305aa&scoped=true"
import script from "./ReadMoreButton.vue?vue&type=script&lang=js"
export * from "./ReadMoreButton.vue?vue&type=script&lang=js"
import style0 from "./ReadMoreButton.vue?vue&type=style&index=0&id=2a3305aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3305aa",
  null
  
)

export default component.exports